var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempColderMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 30C7.975 26.575 4.969 23.394 2.982 20.457C0.995 17.52 0.001 14.801 0 12.3C0 8.55 1.2065 5.5625 3.6195 3.3375C6.0325 1.1125 8.826 0 12 0C15.174 0 17.968 1.1125 20.382 3.3375C22.796 5.5625 24.002 8.55 24 12.3C24 14.8 23.0065 17.519 21.0195 20.457C19.0325 23.395 16.026 26.576 12 30ZM10.962 16.0322V19.3842H12.5774V16.0322L15.2024 18.6169L16.3331 17.4861L12.5774 13.7303V12.1149H14.1928L17.9485 15.8707L19.0793 14.7399L16.4947 12.1149H19.8466V10.4995H16.4947L19.0793 7.87455L17.9485 6.74378L14.1928 10.4995H12.5774V8.88416L16.3331 5.1284L15.2024 3.99763L12.5774 6.58224V3.23032H10.962V6.58224L8.33699 3.99763L7.20622 5.1284L10.962 8.88416V10.4995H9.3466L5.59084 6.74378L4.46007 7.87455L7.04468 10.4995H3.69276V12.1149H7.04468L4.46007 14.7399L5.59084 15.8707L9.3466 12.1149H10.962V13.7303L7.20622 17.4861L8.33699 18.6169L10.962 16.0322Z",
    fill: "#0BB6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempColderMarker);
export default __webpack_public_path__ + "static/media/temp-colder-marker.7bc6de4e6c11d9fce688b404cb7cfed5.svg";
export { ForwardRef as ReactComponent };